import type { Domain } from '@/config/domain/type';

export const trademarkPlanetUnitedKingdom: Domain = {
    domain: import.meta.env.VITE_TMP_UK_DOMAIN,
    website: 'https://www.trademarkplanet.com',
    shortCode: 'tmp-uk',
    markSource: 'TMPV2-UK',
    title: 'Trademark Planet - Apply Now',
    name: 'Trademarks Online United Kingdom',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your UK trademark by entering your trademark or logo.',
    logo: '/img/TMP-Logo.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/uk/pricing' },
        { label: 'FAQ', url: '/uk/faq' },
        { label: 'About', url: '/uk/about' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-of-use' },
        { label: 'Contact Us', url: '/uk/contact' },
    ],
    termOfUseUrl: '/terms-of-use',
    bannerImageUrl: '/img/TMP-Banner-UK-XL.png',
    gtmId: 'GTM-WWPMLP45',
};
